/**
 * Prices travel as integer cents (bazaar items, goal tasks). These helpers
 * are the only place that converts between cents and what people read/type.
 */

export function formatPrice(cents: number | null, currency: string | null = 'EUR'): string | null {
  if (cents == null) return null;
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency ?? 'EUR',
  }).format(cents / 100);
}

/** "12.5" / "12,50" → 1250; blank → null; unparsable → undefined. */
export function parsePriceCents(input: string): number | null | undefined {
  const trimmed = input.trim();
  if (trimmed === '') return null;
  const value = Number(trimmed.replace(',', '.'));
  if (!Number.isFinite(value) || value < 0) return undefined;
  return Math.round(value * 100);
}

/** 1250 → "12.50" for a price input; null → "". */
export function priceInputValue(cents: number | null): string {
  return cents == null ? '' : (cents / 100).toFixed(2);
}
